export default __webpack_public_path__ + "static/media/Frame 8016.48e216f0.svg";